import { HStack, VStack } from "@chakra-ui/react";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import React, { memo, PropsWithChildren } from "react";
import { MESSAGE_STATE } from "modules/utils/Constants";
import useMessageBackground from "modules/hooks/use-message-background";
import UserAvatar from "modules/_shared/user-avatar";
import UserPopover from "modules/_shared/user-popover";
import MessagePopover from "./message-popover/message-popover";
import MessageUserNameDateHeader from "./message-user-name-date-header";
import MessageAvatarHeader from "./message-avatar-header";

interface IProps extends PropsWithChildren {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
  messageState: MESSAGE_STATE;
}

const UserMessageHeader: React.FC<IProps> = ({
  messageThread,
  message,
  messageState,
  children,
}) => {
  const { messageBackground } = useMessageBackground({ message });

  return (
    <VStack alignItems="flex-start" spacing={0} w="full" pb={4}>
      <HStack spacing={0} w="full">
        <MessageAvatarHeader
          color={messageBackground.backgroundColor}
          transition={messageBackground.transition}
        >
          <UserPopover
            messageThread={messageThread}
            userId={message.createdUserId}
          >
            <UserAvatar userId={message.createdUserId} size="sm" />
          </UserPopover>
        </MessageAvatarHeader>
        <MessageUserNameDateHeader message={message} />
      </HStack>
      <MessagePopover
        message={message}
        messageThread={messageThread}
        placement="top-end"
        placementOffset={[6, -20]}
        messageState={messageState}
      >
        {children}
      </MessagePopover>
    </VStack>
  );
};

export default memo(UserMessageHeader);
